import { Component, inject } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, SnackbarComponent, ToastType } from '@program-suite/ui';
import { UI_FORM_IMPORTS } from '../../../ui-form-imports';
import { ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthStore } from '@program-suite/data-auth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangePasswordViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-change-password-modal',
  imports: [
    ModalLayoutComponent,
    ButtonComponent,
    ...UI_FORM_IMPORTS,
    ReactiveFormsModule
],
  templateUrl: './changePasswordModal.component.html',
  styleUrl: './changePasswordModal.component.scss',
})
export class ChangePasswordModalComponent {
  authStore = inject(AuthStore);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ChangePasswordModalComponent>);
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
  ) {
    this.form = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword:['', Validators.required]
    });
  }

  onSubmit() {
    const newPassword = this.form.value.newPassword;
    const confirmPassword = this.form.value.confirmPassword;
    if (newPassword !== confirmPassword) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Error, message: "Passwords do not match" }
      });
      return;
    }

    const cpvm: ChangePasswordViewModel = {
      oldPassword: this.form.value.oldPassword,
      newPassword: this.form.value.newPassword,
    }

    this.authStore.changePassword(cpvm).then(() => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: "Password was successfuly changed." }
      });
    })
    .catch(() => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Error, message: "Passwords do not match" }
      });
    })
    
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
